import { apiClient } from '@/shared/lib/api/api-client'

export const TENANT_LOGO_PATH = '/api/tenants/current/logo'

/**
 * Fetches the active tenant's logo. Returns `null` when the tenant has no logo
 * (404) and also on any other failure: the logo is cosmetic, so the top bar
 * silently falls back to its default branding.
 */
export async function fetchTenantLogo(signal?: AbortSignal): Promise<Blob | null> {
  try {
    return await apiClient.getBlob(TENANT_LOGO_PATH, signal)
  } catch {
    return null
  }
}
